import { defineStore, acceptHMRUpdate } from 'pinia'
import { url } from '@/conf/conf.js';
import { middleware } from "@/services/api/Middleware.js";

export const useVehiclesStore = defineStore({
    id: "vehicles",
	state: () => ({ 
        vehiclesData: [],
        vehicleSelected: "",
        vehiclesNonSelected: {},
        isLoading: true,
        isLoadingVehicle: true,
        isLoadingMoreCards: false,
        offset: 0,
        page: 1,
        maxPages: 0,
        listPage: 1,
        listOffset: 1,
        totalVehicles: 0,
        totalShow: 12, // default
        listVehicles: [],
        filters: {
            plate: '',
            vin: '',
            brand: '',
            model: '',
            client: '',
            itvStartDate: '',
            itvEndDate: '',
            tachographStartDate: '',
            tachographEndDate: '',
            nextVisitStartDate: '',
            nextVisitEndDate: '',
            itvDateWarning: 0
        },
    }),
    getters: { 
        getVehicles(state){
            return state.vehiclesData
        },
        getVehiclesSelected(state) {
            return state.vehicleSelected
        },
        getVehiclesNonSelected(state) {
            return state.vehiclesNonSelected
        },
        getVehiclesLoading(state) {
            return state.isLoading
        },
        getVehicleLoading(state) {
            return state.isLoadingVehicle
        },
        getVehicleLoadingMore(state) {
            return state.isLoadingMoreCards
        },
        getTotalVehicles(state) {
            return state.totalVehicles;
        },
        getTotalVehiclesShow(state) {
            return state.totalShow;
        },
        getListVehicles(state) {
            return state.listVehicles;
        },
        getListPage(state) {
            return state.listPage;
        },
        getMaxPages(state) {
            return state.maxPages;
        },
        getCurrentPage(state) {
            return state.page;
        },
        getSelectedVehicleClients(state) {
            return state.vehicleSelected.clients
        },
        getFilters(state) {
            return state.filters;
        },
    },
    actions: {
        async fetchVehiclesList(params) {
            this.isLoading = true;
            try {
                let options = 
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ 
                            validation_key: params.k,
                            limit: params.limit,
                            offset: params.offset * params.limit,
                            filter: this.filters,
                            sort: params.sort || null, 
                            dir: params.dir || null, 
                            method: "vehiclesSearch"
                        })
                    };
                    return middleware(url, options, ['isTokenAlive'])()
                    .then((response) => response.json())
                    .then((data) => {
                        if(data.errors) {
                            // TODO
                            return data;
                        } else if(data.vehicles.length>0) {
                            this.listPage = params.offset + 1;
                            this.listVehicles = []
                            this.listVehicles = data.vehicles
                            this.totalVehicles = data.count;
                            this.totalShow = data.vehicles.length;
                            this.listPage = params.offset + 1;
                            this.page = params.offset + 1;
                            this.maxPages = Math.ceil(data.count / params.limit) - 1
                        }
                        else {
                            this.totalVehicles = 0;
                            this.listVehicles = [];
                        }
                        this.isLoading = false;
                        return data
                    })
                    .catch((error) => {
                        this.isLoading = false;
                    }
                );
            }
            catch (error) {
            }
        },
        async fetchVehicle(params, vehicleId) {
            this.isLoadingVehicle = true;
            try {
                let options = 
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ 
                            validation_key: params.k,
                            vehicle_id: params.vehicle_id,
                            method: "vehicle"
                        })
                    };
                    return middleware(url, options, ['isTokenAlive'])()
                    .then((response) => response.json())
                    .then((data) => {
                        if(data.errors) {
                            this.isLoadingVehicle = false;
                            return data;
                        } else if(data) {
                            this.vehicleSelected = data;
                            this.isLoadingVehicle = false;
                        }
                        return data
                    })
                    .catch((error) => {
                    }
                );
            }
            catch (error) {
            }
        },
        changeSelected(params, vehicleId) {
            // remove selected
            let index = 0;
            this.vehiclesNonSelected.forEach((object, i) => {
                delete object.selected;
                if(object.id == vehicleId) {
                    index = i;
                }
            });

            let newItem = {
                ...this.vehiclesNonSelected[index],
                selected: true
            };

            this.vehiclesNonSelected.splice(index, 1, newItem)

            this.fetchVehicle(params, vehicleId);
        },
        changeOffset(newOffset) {
            this.offset = newOffset
        },
        changePage(newPage) {
            this.page = newPage;
        },
        loadMoreData(validation, filteredVehicle) {
            if(this.totalVehicles == this.vehiclesData.length) {
                this.offset = this.totalVehicles
            } else {
                this.changeOffset(this.offset + 12);
            }
            this.fetchSearchVehicle({k: validation, offset: this.offset, filter: filteredVehicle});
        },
        loadMoreDataList(validation, filteredVehicle) {
            if (!this.isLoading) {
                if(this.page != this.maxPages) {
                    this.vehiclesData = this.vehiclesNonSelected
                    this.vehiclesNonSelected = {};
                    this.totalShow = this.page * 12;
                } else {
                    this.totalShow = this.totalVehicles;
                }
            }
            this.fetchSearchVehicle({k: validation, offset: this.offset, filter: filteredVehicle});
        },
        async syncVehicle(params) {
            try {
                let options = {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        validation_key: params.k,
                        vehicle_id: params.vehicle_id,
                        method: "vehicleSync"
                    })
                };
                return middleware(url, options, ['isTokenAlive'])()
                    .then((response) => response.json())
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                    });
            } catch (error) {
            }
        },
        setStatusFilters(field, value) {
            return new Promise((resolve) => {
              if(field == "overrideAll"){
                this.filters = value;
              }else if(field == "itvDateWarning"){
                this.filters.itvDateWarning = 1;
              }else if(field == "all"){
                this.filters.itvDateWarning = 0;
              }
              else if(field == "itv"){
                this.filters.itvStartDate = value.startDate;
                this.filters.itvEndDate = value.endDate;
              }
              else if(field == "tachograph"){
                this.filters.tachographStartDate = value.startDate;
                this.filters.tachographEndDate = value.endDate;
              }
              else if(field == "nextVisit"){
                this.filters.nextVisitStartDate = value.startDate;
                this.filters.nextVisitEndDate = value.endDate;
              }
              else if(field == 'fullClientName'){
                this.filters.client = value;
              }else{
                this.filters[field] = value;
              }
              resolve();
            });
          }
    }
});

// by now at least
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useVehiclesStore, import.meta.hot))
}